import { Form } from 'formik';

import styled from '@app/styled';
import { color, font } from '@app/theme';

export const FormSetupWrapper = styled(Form)`
    display: flex;
    flex-direction: column;
    gap: 32px;
`;

export const PageHeading = styled.h1`
    font-size: 30px;
    line-height: 40px;
    font-weight: 600;
    margin: 0;
`;

export const PageParagraph = styled.span`
    color: #808080;
    font-size: 15px;
    line-height: 21px;
    font-family: ${font('family.inter')};
`;

export const SetupWrapper = styled.div`
    max-width: 410px;
    display: flex;
    flex-direction: column;
    gap: 32px;
    opacity: 0;
    transition: opacity 0.5s;
`;

export const ChildrenWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const BackButton = styled.button`
    margin-top: 16px;
    background-color: white;
    border: none;
    font-size: 16px;
    cursor: pointer;
    transition: color 0.2s;

    &:hover {
        color: ${color('custom.interactive.primary.idle')};
    }
`;

export const BackButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
`;
